import {SelectInputElement} from '@/Agent/PreQualification/Components/SelectInputElement';
import {FormType} from '@/Agent/PreQualification/types';
import {Parameter} from '@/Core/mobx/ParameterStore/Parameter';
import {ParameterStore} from '@/Core/mobx/ParameterStore/ParameterStore';
import {Quote} from '@/Core/mobx/ParameterStore/Quote';
import {fieldOptions} from '@/Core/mobx/ParameterStore/QuoteXref';
import {CategoryHeader} from '@/Core/UI';
import {Card, Grid, Typography} from '@material-ui/core';
import {observer} from 'mobx-react-lite';

type AnnuityTabProps = {
    valueChanged: (p: Parameter, value: any, formType?: FormType) => void;
    parameterStore: ParameterStore;
    formType: FormType;
};

const AnnuityTab = observer(({valueChanged, parameterStore, formType}: AnnuityTabProps) => {
    const {quote} = parameterStore;
    const {productAnnuity, monthlyPremiumAnnuity, singlePremiumAnnuity, allocationAnnuity} = quote;
    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    return (
        <>
            <Card
                style={{
                    padding: 20,
                    marginBottom: 10,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                }}
            >
                <Grid
                    item
                    style={{
                        marginBottom: 20,
                    }}
                    xs={12}
                >
                    <CategoryHeader name="Carrier Product" number={1} />
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <SelectInputElement
                            param={{
                                label: 'Product',
                                name: 'productAnnuity',
                                options: fieldOptions.productAnnuity.options,
                                optionValues: fieldOptions.productAnnuity.optionValues,
                                ...quote.productAnnuity,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                            formType={formType}
                            disabled={true}
                        />
                    </Grid>
                </Grid>
                <Grid item style={{marginTop: 20, marginBottom: 20}} xs={12}>
                    <CategoryHeader name="Premium" number={2} />
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Monthly Premium',
                                name: 'monthlyPremiumAnnuity',
                                options: fieldOptions.monthlyPremiumAnnuity.options,
                                optionValues: fieldOptions.monthlyPremiumAnnuity.optionValues,
                                ...quote.monthlyPremiumAnnuity,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Single Premium',
                                name: 'singlePremiumAnnuity',
                                options: fieldOptions.singlePremiumAnnuity.options,
                                optionValues: fieldOptions.singlePremiumAnnuity.optionValues,
                                ...quote.singlePremiumAnnuity,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <SelectInputElement
                            param={{
                                label: 'Premium Allocation',
                                name: 'allocationAnnuity',
                                options: fieldOptions.allocationAnnuity.options,
                                optionValues: fieldOptions.allocationAnnuity.optionValues,
                                ...quote.allocationAnnuity,
                            }}
                            required={required('')}
                            valueChanged={valueChanged}
                            formType={formType}
                        />
                    </Grid>
                </Grid>
            </Card>
        </>
    );
});

export default AnnuityTab;
